import { apiConstants } from '../../apiConstant'
import { serviceCall, serviceCallAuth } from '../../serviceCall'

export const permissionsForDashbaord = (data, callback, errorCallBack) => {
  return async (dispatch) => {
    serviceCall({
      url: apiConstants.PERMISSIONS.GET_PERMISSIONS,
      method: 'get',
      data: data,
    })
      .then((response) => {
        callback && callback(response)
      })
      .catch((error) => {
        errorCallBack && errorCallBack(error.response)
      })
  }
}
